import React from 'react';
import { PriceAnalysisChart } from './PriceAnalysisChart';

interface PriceAnalysisChartWrapperProps {
  startDate: string;
  endDate: string;
  isFullscreen?: boolean;
}

export function PriceAnalysisChartWrapper({ startDate, endDate, isFullscreen = false }: PriceAnalysisChartWrapperProps) {
  return (
    <div className={`text-left h-full w-full flex flex-col ${isFullscreen ? 'p-4' : ''}`}>
      <PriceAnalysisChart 
        startDate={startDate}
        endDate={endDate}
        isFullscreen={isFullscreen}
      />
    </div>
  );
}
